import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PartnerGameAdd.module.scss';
import clsx from 'clsx';
import useModalAddNewGame from '../useModalAddNewGame/useModalAddNewGame';
import { useForm } from 'react-hook-form';
import Block from '../Block/Block';
import Link from '../Link/Link';
import Input from '../Input/Input';
import Button from '../Button/Button';
import { gameList } from '../../redux/actions/game/gameList';
import { gamePartnerAdd } from '../../redux/actions/game/gamePartnerAdd';
import { imageUrl } from '../../utils/imageUrl';
import { gamePartnerList } from '../../redux/actions/game/gamePartnerList';
const PartnerGameAdd = () => {
  const { open } = useModalAddNewGame(() => {
    dispatch(gameList());
  });
  const form = useForm({ defaultValues: { gameId: '', percent: '', innerId: '' }, reValidateMode: 'onChange' });
  const dispatch = useDispatch();
  const {
    gameList: { data: gameListData, loading: gameListLoading, error: gameListError },
    gamePartnerAdd: { data: gamePartnerAddData, loading: gamePartnerAddLoading, error: gamePartnerAddError },
  } = useSelector((state) => state.game);

  const [gameOptions, setGameOptions] = useState([]);
  useEffect(() => {
    dispatch(gameList());
  }, []);
  useEffect(() => {
    if (gameListData) {
      setGameOptions([{ label: 'Выберите игру', value: '' }, ...gameListData?.map((game) => ({ label: game?.name, value: game?.id, image: imageUrl(game?.logo) }))]);
    }
  }, [gameListData]);
  useEffect(() => {
    if (gamePartnerAddData) {
      dispatch(gamePartnerList());
      form.reset();
    }
  }, [gamePartnerAddData]);

  const onAddGame = (data) => {
    dispatch(gamePartnerAdd(data));
  };
  return (
    <>
      <Block title="Игры">
        <div className={clsx(styles.text)}>Из выпадающего списка выберите игру, укажите внутренний ID в вашей базе, который соответствует игре и укажитескидку.</div>
        <div className={clsx(styles.row)}>
          <Input type={'select'} className={clsx(styles.selectGame)} name="gameId" form={form} list={gameOptions} />
          <Input type={'text'} className={clsx(styles.inputGameId)} name="innerId" form={form} label="ID игры в вашей системе" /> <Input type={'number'} className={clsx(styles.inputPercent)} name="percent" form={form} label="% скидки" suffix={'%'} />
        </div>
        <Button
          type="success"
          className={clsx(styles.btnCreate)}
          onClick={form.handleSubmit(onAddGame)}
          rightIcon={
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          }>
          Добавить
        </Button>
        <Link
          className={clsx(styles.linkNewProduct)}
          onClick={() => {
            open();
          }}>
          Добавить продукт не из списка
        </Link>
      </Block>
    </>
  );
};

export default PartnerGameAdd;
